__turbopack_context__.v({
  "desktopLink": "chat-link-module-scss-module__Z3xr9W__desktopLink",
  "mobileLink": "chat-link-module-scss-module__Z3xr9W__mobileLink",
});
